module.exports = __webpack_public_path__ + "static/img/文化旅游展厅.3a08b534.png";